(function() {
	// Rellax
	window.addEventListener('load', function () {
		new Rellax('.js-rellax', {
			center: true,
		});

		new Rellax('.js-rellax-horizontal', {
			horizontal: true,
			vertical: true
		});
	});
})();